/** "24%" → 24. A blank or non-percent label is not a rate. */
export function vatPercent(label: string | null | undefined): number | null {
  if (!label) return null
  const match = label.trim().match(/^(\d+(?:[.,]\d+)?)\s*%$/)
  if (!match) return null
  const percent = Number(match[1].replace(',', '.'))
  return Number.isFinite(percent) && percent > 0 ? percent : null
}

/**
 * VAT already inside a VAT-inclusive amount, in cents.
 * {@code gross × rate / (1 + rate)}, rounded to the cent.
 */
export function includedVatCents(grossCents: number, percent: number): number {
  if (!Number.isFinite(grossCents) || grossCents === 0 || !Number.isFinite(percent) || percent <= 0) return 0
  return Math.round((grossCents * percent) / (100 + percent))
}

export function lineGrossCents(line: { quantity: number; unitPrice: string }): number {
  const price = Number(line.unitPrice)
  if (!Number.isFinite(price)) return 0
  return Math.round(line.quantity * price * 100)
}

/** Sum of the VAT inside each line. A line with no catalog rate adds nothing. */
export function linesVatCents(
  lines: { quantity: number; unitPrice: string; vat?: string | null }[],
): number {
  return lines.reduce((sum, line) => {
    const percent = vatPercent(line.vat)
    if (percent == null) return sum
    return sum + includedVatCents(lineGrossCents(line), percent)
  }, 0)
}
